import { hasPermission } from "../../utils/permissions"

/**
 * PermissionGuard component to conditionally render UI elements based on permissions
 * Usage: <PermissionGuard permission="library:create"><button>Add Library</button></PermissionGuard>
 */
export default function PermissionGuard({ permission, children, fallback = null }) {
    if (!hasPermission(permission)) {
        return fallback
    }

    return children
}
